module.exports = __webpack_public_path__ + "static/img/listTc.8d41028.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/listTc.jpg
// module id = rukJ
// module chunks = 1